/**
 * Use Case: Validate Voucher Codes File
 * Business logic for validating a CSV or XLSX file containing voucher codes.
 */

import type { VoucherCodesValidationResult } from "../model/RewardCatalogModel";
import type { IRewardCatalogRepository } from "../repository/IRewardCatalogRepository";
import { rewardCatalogContainer, TYPES } from "../../di/RewardCatalogModule";

/**
 * Validate a voucher codes file (CSV or XLSX)
 * @param file The file to validate
 * @returns Validation result with counts, errors, warnings, and duplicate codes
 */
export const ValidateVoucherCodesFileUseCase = async (
  file: File
): Promise<VoucherCodesValidationResult> => {
  const repository = rewardCatalogContainer.get<IRewardCatalogRepository>(
    TYPES.IRewardCatalogRepository
  );
  return repository.validateVoucherCodesFile(file);
};

